import * as React from "react";
import { SquareCard } from "../common/SquareCard";
import {
  Box,
  Link as ExternalLink,
  Stack,
  Typography,
  Grid,
} from "@mui/material";
import { StaticImage } from "gatsby-plugin-image";
import { FormattedMessage } from "../utils/FormattedMessage";
import { useIntl } from "gatsby-plugin-intl";
import { googleMapsUrl } from "../utils/constants";

function OpeningTimeAndMap() {
  const { formatMessage } = useIntl();
  const phone = formatMessage({
    id: "common.contacts.reference_1.phone",
  });

  return (
    <Box
      sx={{
        maxWidth: 1200,
        mx: "auto",
        px: {
          xs: 2,
          sm: 4,
          md: 6,
        },
      }}
    >
      <SquareCard>
        <Grid container spacing={4}>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <Stack mb={2} gap={3} p={4}>
              <Typography variant="h3">
                <FormattedMessage id="contacts.opening_time.title" />
              </Typography>
              <Typography variant="body1" component="div">
                <FormattedMessage
                  id="contacts.opening_time.body"
                  values={{
                    reference_name: (
                      <FormattedMessage id="common.contacts.reference_1.name" />
                    ),
                    reference_phone: (
                      <ExternalLink color="inherit" href={`tel:${phone}`}>
                        {phone}
                      </ExternalLink>
                    ),
                  }}
                />
              </Typography>
            </Stack>
            <Box
              sx={{
                display: { xs: "none", md: "block" },
              }}
            >
              <StaticImage
                src="../../images/contacts/aviosuperficie-scuola-volo-asti.jpg"
                alt="Aviosuperficie scuola volo Asti: orari apertura, servizi per piloti e appassionati in Piemonte"
                placeholder="blurred"
                layout="fullWidth"
                aspectRatio={3 / 2}
                transformOptions={{
                  cropFocus: "center",
                }}
              />
            </Box>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <ExternalLink
              href={googleMapsUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Google Maps"
            >
              <Box
                sx={{
                  display: { xs: "none", md: "block" },
                  height: "100%",
                }}
              >
                <StaticImage
                  src="../../images/contacts/map.png"
                  alt="Mappa aviosuperficie scuola volo Asti: posizione, indicazioni stradali, servizi per piloti"
                  placeholder="blurred"
                  layout="fullWidth"
                  aspectRatio={3 / 4}
                  transformOptions={{
                    cropFocus: "center",
                  }}
                  style={{
                    height: "100%",
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                <StaticImage
                  src="../../images/contacts/map.png"
                  alt="Mappa aviosuperficie scuola volo Asti: posizione, indicazioni stradali, servizi per piloti"
                  placeholder="blurred"
                  layout="fullWidth"
                  aspectRatio={16 / 9}
                  transformOptions={{
                    cropFocus: "center",
                  }}
                  style={{
                    height: "100%",
                  }}
                />
              </Box>
            </ExternalLink>
          </Grid>
        </Grid>
      </SquareCard>
    </Box>
  );
}

export { OpeningTimeAndMap };
